import { CheckCircleIcon } from "@heroicons/react/24/solid";

import { formatIsoDateTime } from "./helpers";
import type { ResolvedConfirmationEvent } from "./types";

/**
 * Renders an arrangement confirmation event ("Confirmed by {name} at {time}")
 * using the display names after-api resolves server-side — the frontend never
 * looks up people directly. Shared by the selections-review and
 * payment-confirmation screens via the `subject` prop.
 */
export default function ConfirmationEventDisplay({
  event,
  subject = "Confirmed",
}: {
  event: ResolvedConfirmationEvent;
  subject?: string;
}) {
  const when = formatIsoDateTime(event.confirmed_at);
  const name = event.confirmed_by_name;

  return (
    <div className="flex items-start gap-3 rounded-lg bg-sage/10 p-4">
      <CheckCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-sage" />
      <div className="text-left">
        <p className="font-medium text-evergreen">
          {name ? `${subject} by ${name}` : subject}
          {when ? ` at ${when}` : ""}
        </p>
        {event.attested_for_name && (
          <p className="mt-1 text-sm text-soil">
            Attested to be acting for {event.attested_for_name}
          </p>
        )}
      </div>
    </div>
  );
}
